import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MicroTimeInputContext = /*#__PURE__*/createContext(undefined);
export const MicroTimeInputProvider = ({
  microInputStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    microInputStyleOverrides
  }), [microInputStyleOverrides]);
  return /*#__PURE__*/_jsx(MicroTimeInputContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `MicroTimeInput` component.
 * Note: The context is only available when the `MicroTimeInput` component is rendered as an ancestor.
 * @returns MicroTimeInputContext - The context for the `MicroTimeInput` component.
 * @returns MicroTimeInputContext.microInputStyleOverrides - Style overrides to be applied to the `DialogButton` component.
 */
export const useMicroTimeInputContext = () => {
  const microTimeInputContext = useContext(MicroTimeInputContext);
  return microTimeInputContext;
};